// extracted by mini-css-extract-plugin
export default {"PropertyCard":"PropertyCard_PropertyCard__xRyaV"};